var _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgodaoBgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356,
    height: 402,
    viewBox: "0 0 356 402",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.893 0.979492C152.375 23.5154 134.97 54.4341 62.7891 73.8128",
    stroke: "url(#paint0_linear_38_456)",
    strokeWidth: 0.479167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.102 0.979492C193.565 23.5154 210.888 54.4341 282.727 73.8128",
    stroke: "url(#paint1_linear_38_456)",
    strokeWidth: 0.479167
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.528,
    cy: 223.512,
    r: 165.143,
    stroke: "url(#paint2_linear_38_456)",
    strokeWidth: 0.425213
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.528,
    cy: 223.512,
    r: 165.143,
    stroke: "#D95650",
    strokeOpacity: 0.18,
    strokeWidth: 0.425213
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.526 55.8129C270.145 55.8129 345.227 130.895 345.227 223.513C345.227 316.132 270.145 391.214 177.526 391.214C84.9079 391.214 9.82588 316.132 9.82588 223.513C9.82588 130.895 84.9079 55.8129 177.526 55.8129Z",
    stroke: "url(#paint3_linear_38_456)",
    strokeWidth: 0.425213
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.526 55.8129C270.145 55.8129 345.227 130.895 345.227 223.513C345.227 316.132 270.145 391.214 177.526 391.214C84.9079 391.214 9.82588 316.132 9.82588 223.513C9.82588 130.895 84.9079 55.8129 177.526 55.8129Z",
    stroke: "#D95650",
    strokeOpacity: 0.18,
    strokeWidth: 0.425213
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.53,
    cy: 223.523,
    r: 170.933,
    transform: "rotate(-90 177.53 223.523)",
    stroke: "url(#paint4_linear_38_456)",
    strokeWidth: 0.388489
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.523,
    cy: 223.523,
    r: 177.135,
    transform: "rotate(-90 177.523 223.523)",
    stroke: "url(#paint5_linear_38_456)",
    strokeWidth: 0.776977
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_456",
    x1: 163.893,
    y1: 3.48348,
    x2: 139.14,
    y2: 89.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251326,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_456",
    x1: 182.102,
    y1: 3.48348,
    x2: 206.954,
    y2: 89.7913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251326,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_456",
    x1: 296.115,
    y1: 340.677,
    x2: 52.805,
    y2: 119.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239249,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716165,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7544F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_456",
    x1: 296.504,
    y1: 103.093,
    x2: 71.9801,
    y2: 350.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239249,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716165,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7544F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38_456",
    x1: 300.255,
    y1: 344.778,
    x2: 48.4536,
    y2: 115.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239249,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716165,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7544F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38_456",
    x1: 168.547,
    y1: 395.561,
    x2: 180.017,
    y2: 48.4933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239249,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716165,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7544F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgodaoBgSm);
export default __webpack_public_path__ + "static/media/algodao-bg-sm.02ebbc52150d71e62f241a6ffbbb5ab2.svg";
export { ForwardRef as ReactComponent };